import ReturnsGuestForm from '@moncler/components/clientService/ReturnsGuestForm';
import ReturnsOrdersListing from '@moncler/components/clientService/ReturnsOrdersListing';
import { UserInfoActionTypes } from '@state/features/common.types';
import { isUserAuthenticated } from '@state/features/orders.selectors';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
const ReturnFormPage = (props) => {
    const { t } = useTranslation();
    const { loading: waitingUserInfo, user: { isAuthenticated }, } = useSelector(isUserAuthenticated);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch({
            type: UserInfoActionTypes.FETCH_USERINFO,
        });
    }, []);
    if (waitingUserInfo) {
        return React.createElement("div", { className: "hiddenloading" });
    }
    if (isAuthenticated || props.displayOrders) {
        return (React.createElement("div", { className: "client-service" },
            React.createElement(ReturnsOrdersListing, Object.assign({}, props, { title: t('button.returnorder'), description: t('exchanges.selectorder') }))));
    }
    return (React.createElement("div", { className: "client-service" },
        React.createElement(ReturnsGuestForm, Object.assign({}, props))));
};
export default ReturnFormPage;
